
import { CheckInLog } from "@/types/CheckInLog";
import {
  CheckInKpi,
  CheckInTimeseriesPoint,
  CheckInTimeseriesUnit,
} from "@/types/CheckInKpi";
import { Filter } from "@/types/Filter";
import {
  getPaginatedCheckInLogs as getPaginatedCheckInLogsApi,
  getCheckInLogCount as getCheckInLogCountApi,
  getCheckInLogKpiSummary as getCheckInLogKpiSummaryApi,
  getCheckInLogTimeseries as getCheckInLogTimeseriesApi,
} from "@/lib/api/clients/CheckInLogClient";
import { handleErrorServer, ServerError } from "@/lib/api/errors/ErrorHandler";
import { isValidObjectId } from "@/lib/utils/input-validator";

export async function getCheckInLogs(
  eventId: string,
  searchTerm: string,
  page: number,
  pageSize: number,
  filters: Filter[],
  sortBy: string = "createdAt",
  sortOrder: "asc" | "desc" = "desc",
): Promise<CheckInLog[] | ServerError> {
  try {

    if (!isValidObjectId(eventId)) throw new Error("validationError");
    if (pageSize < 1 || pageSize > 100) throw new Error("validationError");
    if (page < 0) throw new Error("validationError");

    const response = await getPaginatedCheckInLogsApi(
      eventId,
      searchTerm,
      page,
      pageSize,
      filters,
      sortBy,
      sortOrder,
    );

    if (!Array.isArray(response)) throw new Error("unknown");

    return response;
  } catch (error) {
    console.error("Error in getCheckInLogs:", error);
    return handleErrorServer(error);
  }
}

export async function getCheckInLogCount(
  eventId: string,
  filters: Filter[] = [],
  searchTerm: string = "",
): Promise<number | ServerError> {
  try {

    if (!isValidObjectId(eventId)) throw new Error("validationError");

    return await getCheckInLogCountApi(
      eventId,
      filters,
      searchTerm,
    );
  } catch (error) {
    console.error("Error in getCheckInLogCount:", error);
    return handleErrorServer(error);
  }
}

export async function getCheckInKpiSummary(
  eventId: string,
  range?: { from?: string; to?: string },
): Promise<CheckInKpi | ServerError> {
  try {
    if (!isValidObjectId(eventId)) throw new Error("validationError");

    return await getCheckInLogKpiSummaryApi(eventId, range);
  } catch (error) {
    console.error("Error in getCheckInKpiSummary:", error);
    return handleErrorServer(error);
  }
}

export async function getCheckInTimeseries(
  eventId: string,
  unit: CheckInTimeseriesUnit,
  range?: { from?: string; to?: string },
): Promise<CheckInTimeseriesPoint[] | ServerError> {
  try {
    if (!isValidObjectId(eventId)) throw new Error("validationError");

    const response = await getCheckInLogTimeseriesApi(eventId, unit, range);
    if (!Array.isArray(response)) throw new Error("unknown");

    return response;
  } catch (error) {
    console.error("Error in getCheckInTimeseries:", error);
    return handleErrorServer(error);
  }
}
